import { useQuery } from '@tanstack/react-query';

import { useConfig } from '../default-config';
import { LaanerammeWeb } from '../generated-types';
import restClient from '../util/web-http-client';

const setHeader = (bankregnr: string | undefined): HeadersInit => {
    return {
        'X-BankRegNr': bankregnr!,
    };
};

export const useMarkedsrente = () => {
    const { bankregnr } = useConfig();
    return useQuery({
        queryKey: ['markedsRente'],
        queryFn: () => restClient.getMarkedsrente(setHeader(bankregnr)),
    });
};

export const useLaaneramme = (laaneramme: LaanerammeWeb) => {
    const { bankregnr } = useConfig();
    return useQuery({
        queryKey: [
            'maksLaaneramme',
            laaneramme.aarsinntekt,
            laaneramme.antallLaantakere,
            laaneramme.antallBarn,
            laaneramme.antallBiler,
            laaneramme.gjeld,
        ],
        queryFn: () => restClient.getLaaneramme(laaneramme, setHeader(bankregnr)),
        enabled: laaneramme.aarsinntekt > 100000 && laaneramme.antallLaantakere > 0,
    });
};
